import { render, staticRenderFns } from "./mapafrequencia.vue?vue&type=template&id=38630ff3&"
import script from "./mapafrequencia.vue?vue&type=script&lang=js&"
export * from "./mapafrequencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports